import { Icon } from '@genial/components';
import React from 'react';

import { TableContent, TableContentItemColumn } from '../../../../../components/TableContent';
import {
  ButtonSkeleton,
  StatusSkeleton,
  TextSkeleton,
} from '../../../../BatchTicket/components/DynamicAsset/components/AssetsLoading';
import { ordersHistoryTableHead } from '../../constants';

export const OrderHistoryItemLoadingDesktop: React.FC = () => {
  const getFlex = (index: number) => {
    const currentHead = ordersHistoryTableHead.find((_, i) => i === index);
    return currentHead?.flex || 1;
  };

  return (
    <TableContent direction="row" space={0} p={0} px="inline.xxxs" h="70px">
      <TableContentItemColumn flex={getFlex(0)}>
        <Icon name="Pdf" size="xs" color="neutral.medium" />
      </TableContentItemColumn>
      <TableContentItemColumn flex={getFlex(1)}>
        <TextSkeleton />
      </TableContentItemColumn>
      <TableContentItemColumn flex={getFlex(2)}>
        <TextSkeleton />
      </TableContentItemColumn>
      <TableContentItemColumn flex={getFlex(3)}>
        <TextSkeleton />
      </TableContentItemColumn>
      <TableContentItemColumn flex={getFlex(4)}>
        <TextSkeleton />
      </TableContentItemColumn>
      <TableContentItemColumn flex={getFlex(5)}>
        <TextSkeleton />
      </TableContentItemColumn>
      <TableContentItemColumn flex={getFlex(6)}>
        <TextSkeleton />
      </TableContentItemColumn>
      <TableContentItemColumn flex={getFlex(7)}>
        <TextSkeleton />
      </TableContentItemColumn>
      <TableContentItemColumn flex={getFlex(8)}>
        <StatusSkeleton />
      </TableContentItemColumn>
      <TableContentItemColumn flex={getFlex(9)}>
        <ButtonSkeleton />
      </TableContentItemColumn>
    </TableContent>
  );
};
